import { render, staticRenderFns } from "./EditGate.vue?vue&type=template&id=8728074c&scoped=true"
import script from "./EditGate.vue?vue&type=script&lang=js"
export * from "./EditGate.vue?vue&type=script&lang=js"
import style0 from "./EditGate.vue?vue&type=style&index=0&id=8728074c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8728074c",
  null
  
)

export default component.exports